import axios from 'axios';
import { cookieServices } from 'services/cookieServices';
import { getEnvVariable } from 'utils/helper/lib';

const userInfor = cookieServices.getUserInfo();

export const getServerUrl = () => {
  const dataSource = cookieServices.getDataSource();
  return dataSource === 'live'
    ? getEnvVariable('REACT_APP_LIVE_SERVER_URL')
    : getEnvVariable('REACT_APP_DEV_SERVER_URL');
};

// * Live2D Viewer, Downloader
export const LIVE2D_VIEWER_URL = getEnvVariable('REACT_APP_LIVE2D_VIEWER_URL');
export const LIVE2D_DOWNLOADER_URL = getEnvVariable(
  'REACT_APP_LIVE2D_DOWNLOADER_URL',
);
export const KEVIN_SERVER = getServerUrl();

// ** 제작시스템 테스트 서버
export const ifyouApi = axios.create({
  baseURL: getEnvVariable('REACT_APP_IFYOU_API_URL'),
});

// ** 게임 테스트 서버
export const ifyouApiGame = axios.create({
  baseURL: getEnvVariable('REACT_APP_IFYOU_API_GAME_URL'),
});

// ** 제작시스템 라이브 서버 - 유저, 메일 관리에서 사용
export const ifyouApiLive = axios.create({
  baseURL: getEnvVariable('REACT_APP_IFYOU_API_LIVE_URL'),
});

// ** 작품 배포 서버
export const projectDeployServerApi = axios.create({
  baseURL: getEnvVariable('REACT_APP_PROJECT_DEPLOY_SERVER_API_URL'),
  // baseURL: 'https://pierstory.info:6370',
});

// * 인증이 함께 진행되는 케빈 API
export const kevinAuthAPI = axios.create({
  baseURL: KEVIN_SERVER,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json;charset=UTF-8',
  },
});
kevinAuthAPI.defaults.headers.common['x-jwt'] = userInfor?.accessToken;
kevinAuthAPI.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (!originalRequest) {
      return Promise.reject(error);
    }

    // 401 에러이고 재시도하지 않은 요청일 경우
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        // 새로운 액세스 토큰 받아오기
        const response = await kevinAuthAPI.post(
          '/account/refresh-token',
          null,
          {
            headers: { 'x-refresh-token': userInfor?.refreshToken },
          },
        );

        const newAccount = response.data;
        const currentUser = cookieServices.getUserInfo();
        currentUser.refreshToken = newAccount.refreshToken;
        currentUser.accessToken = newAccount.accessToken;
        cookieServices.setUserInfo(currentUser, true);

        // 새로운 토큰으로 글로벌 헤더 업데이트
        kevinAuthAPI.defaults.headers.common['x-jwt'] = currentUser.accessToken;

        // 새로운 토큰으로 원래 요청의 헤더 업데이트
        if (originalRequest.headers) {
          originalRequest.headers['x-jwt'] = currentUser.accessToken;
        }
        return kevinAuthAPI(originalRequest);
      } catch (refreshError) {
        // refresh token도 만료되었거나 오류가 발생한 경우
        // 로그아웃 처리 또는 로그인 페이지로 리다이렉트
        cookieServices.removeUserInfo();
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  },
);
// * 인증이 필요없는 케빈 API
export const kevinCommonAPI = axios.create({
  baseURL: KEVIN_SERVER,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json;charset=UTF-8',
  },
});

export const COMMON = `/common`;
export const STORY = `/story`;
export const BUBBLE = `/bubble`;
export const SPRITE = `/sprite`;
export const ADMIN = `/admin`;
export const STORE = `/store`;
export const CENTRAL = `/central`;
export const DEPLOY = '/deploy';

// * 생성된 api에 대해서 interceptor 설정 진행
ifyouApi.interceptors.request.use(
  // 요청 보내기 전에 수행할 일
  function (request) {
    if (global.user_id) {
      // data에 admin_id, lang 추가
      // ! GET 방식에서는 data에 데이터가 들어가지 않아서 헤더로 변경.
      if (request.headers) {
        request.headers.x_admin = global.user_id; // 헤더에 추가할 수 있음
        request.headers.x_lang = global.lang ? global.lang : 'KO';
      }
    }
    return request;
  },

  // 에러 요청 보내기 전에 수행할 일
  function (error) {
    return Promise.reject(error);
  },
);
